import { render, staticRenderFns } from "./SchoolDate.vue?vue&type=template&id=6ab76df0&scoped=true&"
import script from "./SchoolDate.vue?vue&type=script&lang=js&"
export * from "./SchoolDate.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDate.vue?vue&type=style&index=0&id=6ab76df0&scoped=true&lang=less&"
import style1 from "./SchoolDate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab76df0",
  null
  
)

export default component.exports